<template>
  <b-modal
    id="modal-value"
    :title="titleModal"
    no-close-on-backdrop
    no-close-on-esc
    hide-header-close
    hide-footer
    scrollable
    centered
    size="lg"
    @hidden="resetModal"
  >
    <template v-if="mxIsDevelopment">
      <FormulateInput
        v-model="inDevMode"
        name="devMode"
        type="checkbox"
        label="DEV"
      />
    </template>

    <FormulateForm
      ref="formReceiveValue"
      name="formReceiveValue"
      @submit="onConfirm"
    >
      <b-container>
        <b-row v-if="isAtm">
          <b-col class="d-flex flex-column justify-content-center align-items-center">
            <p class="h4">
              Valor a ser pago
            </p>
            <p class="h4 mb-0">
              {{ form.value | currency }}
            </p>
          </b-col>
        </b-row>

        <b-row v-if="!isAtm">
          <b-col>
            <div class="d-flex align-items-center">
              <FormulateInput
                id="modal_value-input_value"
                v-model="form.value"
                name="valueReceive"
                class="mr-1 input-size"
                :label="$t('Valor recebido')"
                type="text-number"
                currency="R$"
                :precision="2"
                validation="required|min:0.01"
                :disabled="disableInput"
                @input="onValueTyped"
              />
              <!-- placement: tooltipPosition, -->
              <b-button
                id="modal_value-btn_reset_value"
                variant="danger"
                class="p-1"
                :disabled="disableInput"
                @click="onResetValue"
              >
                <feather-icon
                  icon="DeleteIcon"
                  size="20"
                />
              </b-button>
            </div>
          </b-col>
          <b-col>
            <div class="d-flex justify-content-between align-items-end">
              <p class="h5">
                Saldo restante:
              </p>
              <p class="h5">
                {{ balanceValueUpdated | currency }}
              </p>
            </div>
            <div
              v-if="change > 0"
              class="d-flex justify-content-between align-items-end"
            >
              <p class="h5">
                Troco:
              </p>
              <p class="h5">
                {{ change | currency }}
              </p>
            </div>
          </b-col>
        </b-row>

        <template v-if="hasPaymentMethodInterfaces">
          <b-row>
            <b-col>
              <FormulateInput
                id="method-interface"
                v-model="form.paymentMethodInterface"
                type="radio"
                :options="paymentMethodInterfacesOption"
                :label="$t('Pagar com')"
                :element-class="['d-flex', 'mt-1']"
                :disabled="disableInput"
              />
            </b-col>
          </b-row>
          <!--
            Parcelamento no crédito com TEF. O bloco só aparece quando a política resolvida oferece
            mais de uma parcela: numa loja sem parcelamento configurado a tela permanece como hoje.
          -->
          <template v-if="showInstallmentSelector">
            <b-row>
              <b-col md="6">
                <!--
                  append-to-body: sem isso a lista abre DENTRO do modal, que tem overflow
                  próprio, e o modal ganha barra de rolagem em vez de a lista aparecer por cima.
                -->
                <FormulateInput
                  id="modal_value-installments"
                  v-model="form.installmentCount"
                  name="installmentCount"
                  type="vue-select"
                  :label="$t('Parcelamento')"
                  :clearable="false"
                  :append-to-body="true"
                  :options="installmentSelectOptions"
                  :disabled="disableInput"
                  @input="onChangeInstallments"
                />
              </b-col>
              <b-col
                v-if="showModeSelector"
                md="6"
              >
                <!--
                  A modalidade só é perguntada quando a política permite mais de uma. Permitindo
                  apenas uma, ela é aplicada em silêncio: perguntar algo com resposta única só
                  atrasa o caixa.
                -->
                <FormulateInput
                  id="modal_value-installment-mode"
                  v-model="form.installmentMode"
                  name="installmentMode"
                  type="vue-select"
                  :label="$t('Modalidade')"
                  :clearable="false"
                  :append-to-body="true"
                  :options="installmentModeOptions"
                  :disabled="disableInput"
                />
              </b-col>
            </b-row>


            <!--
              Sinaliza que as opções vieram do cache local. O operador precisa saber que a política
              pode ter mudado desde a última comunicação — é melhor vender com um aviso do que
              travar o caixa.
            -->
            <!--
              No POS o PDV não comanda a maquininha: o que o operador escolhe aqui é o registro do
              que precisa ser feito no equipamento. Se as duas escolhas divergirem, a venda fecha
              com um parcelamento diferente do que o cliente pagou — e, ao contrário do TEF, não há
              retorno da adquirente para o Sistema conferir.
            -->
            <b-row v-if="isPosCreditMethod">
              <b-col>
                <b-alert
                  show
                  variant="primary"
                  class="p-1 mb-1"
                >
                  <feather-icon icon="CreditCardIcon" />
                  {{
                    $t(
                      'Selecione o mesmo parcelamento na maquininha. O Sistema registra o que for informado aqui, sem conferir com o equipamento.'
                    )
                  }}
                </b-alert>
              </b-col>
            </b-row>

            <b-row v-if="installmentOptionsFromCache">

              <b-col>
                <b-alert
                  show
                  variant="secondary"
                  class="p-1 mb-1"
                >
                  <feather-icon icon="WifiOffIcon" />
                  {{
                    $t(
                      'Sem comunicação com o servidor. As opções de parcelamento são as da última consulta e podem estar desatualizadas.'
                    )
                  }}
                </b-alert>
              </b-col>
            </b-row>
          </template>

          <b-row v-if="isPOSMethod">

            <b-col md="12">
              <FormulateInput
                id="modal_value-input_nsu"
                v-model="form.nsu"
                name="nsu"
                type="number"
                class="required"
                validation="required|matches:/^[1-9][0-9]*/"
                :placeholder="$t('0000000')"
                :label="$t('Código de Autorização (NSU)')"
                :disabled="disableInput"
              />
            </b-col>
            <b-col
              v-if="!isPixMethod"
              md="12"
            >
              <FormulateInput
                id="modal_value-input_card_brand"
                v-model="form.cardBrand"
                :label="$t('Bandeira do cartão')"
                class="required"
                validation="required"
                name="cardBrand"
                type="e-radio-icon"
                :combo-options="cardBrands()"
                :disabled="disableInput"
              />
            </b-col>
          </b-row>

          <b-row v-if="isManualPixMethod">
            <b-col>
              <FormulateInput
                id="modal_value-input_document_titular"
                v-model="form.documentTitular"
                v-mask="['###.###.###-##', 'XX.XXX.XXX/XXXX-##']"
                name="documentTitular"
                type="text"
                validation="optional|cpfCnpj"
                :validation-messages="{
                  cpfCnpj: $t('Documento inválido'),
                }"
                :placeholder="$t('Documento')"
                :label="$t('Documento do titular (CPF ou CNPJ)')"
                :disabled="disableInput"
              />
            </b-col>
          </b-row>
        </template>

        <b-row class="mt-1">
          <b-col class="d-flex justify-content-end">
            <e-button
              id="modal_value-btn_cancel"
              class="mr-1"
              variant="danger"
              :text="$t('Cancelar')"
              :text-shortcuts="hasShortcut ? ['ESC'] : []"
              :busy="loadingPaymentConfirmation"
              @click="hideModal"
            />
            <e-button
              id="modal_value-btn_confirm"
              variant="primary"
              text="Confirmar"
              :text-shortcuts="hasShortcut ? ['CTRL', 'ENTER'] : []"
              :busy="isBusy"
              @click="onConfirm"
            />
          </b-col>
        </b-row>
      </b-container>
    </FormulateForm>
  </b-modal>
</template>

<script>
import { BModal, BContainer, BRow, BCol, BButton, BAlert } from 'bootstrap-vue'
import _ from 'lodash'
import {
  keyboardCode,
  paymentTypes,
  loadingOverlay,
  formulateHelper,
  cardDomain,
  devUtils,
} from '@/mixins'
import EButton from '@/views/components/EButton.vue'
import { roundDecimal } from '@/utils/number-utils'
import { getInitialReceiptForm } from '@/store/pages/pdv/pay-box'
import { mapGetters, mapActions, mapState } from 'vuex'
import { Shortcuts } from 'shortcuts'
import { validateBr } from 'js-brasil'
import { initMonitoring } from '@/frontend-monitoring'
import moment from 'moment'
import { isTefCard, isTefPix } from '@/store/utils/paybox/paybox-payments'

const { paymentMethodInterfaceEnum } = paymentTypes.data()

export default {
  components: { BModal, BContainer, BRow, BCol, BButton, BAlert, EButton },

  mixins: [paymentTypes, cardDomain, keyboardCode, loadingOverlay, formulateHelper, devUtils],

  props: {
    saleUuid: {
      type: String,
      required: true,
    },
    balanceValue: {
      type: Number,
      required: true,
    },
    btnConfirmBusy: {
      type: Boolean,
      default: false,
    },

    isAtm: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      form: getInitialReceiptForm(),
      titleModal: '',
      change: 0,
      balanceValueUpdated: 0,
      shortcuts: new Shortcuts(),
      loadingPaymentConfirmation: false,
      inDevMode: false,
    }
  },
  computed: {
    ...mapGetters('pages/pdv/payBoxConfiguration', {
      tefAgentConfigPayload: 'tefAgentConfigPayload',
      isTefEnabled: 'isTefEnabled',
      stIsInstallmentEnabled: 'isInstallmentEnabled',
      stIsPosInstallmentEnabled: 'isPosInstallmentEnabled',
    }),
    ...mapState('pages/pdv/payBoxInstallment', {
      installmentOptionsFromCache: 'fromCache',
    }),
    ...mapGetters('pages/pdv/payBoxInstallment', {
      stInstallmentOptions: 'installmentOptions',
      stHasInstallmentOptions: 'hasInstallmentOptions',
      stAllowedModes: 'allowedModes',
      stDefaultMode: 'defaultMode',
      stApplySurchargeToCustomer: 'applySurchargeToCustomer',
      stOptionByInstallments: 'optionByInstallments',
    }),

    ...mapGetters('pages/pdv/payBox', ['getCustomerDocument']),

    isBusy() {
      return this.loadingPaymentConfirmation || this.btnConfirmBusy
    },
    disableInput() {
      return this.loadingPaymentConfirmation
    },
    hasShortcut() {
      return !this.isAtm
    },

    paymentMethodInterfacesOption() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.form.paymentMethodInterface = this.isTefEnabled
        ? paymentMethodInterfaceEnum.TEF
        : paymentMethodInterfaceEnum.POS

      return this.paymentMethodInterfaces
        .filter(m => (this.isTefEnabled ? true : m !== 'Tef'))
        .map((m, index) => {
          const shortcut = this.paymentMethodInterfacesShorcuts[index].shortcut || ''
          const shortcutLabel = shortcut ? `[${shortcut}] ` : ''

          return {
            label: this.$t(`${shortcutLabel}${m}`),
            value: m,
            'data-testid': `modal_value-radio-pay_with-${m}`,
          }
        })
    },
    paymentMethodInterfaces() {
      const hasInterfaces = [
        this.paymentTypeEnum.CREDIT_CARD,
        this.paymentTypeEnum.DEBIT_CARD,
        this.paymentTypeEnum.PIX,
      ]
      if (!hasInterfaces.includes(this.form.paymentMethod.method)) {
        return []
      }

      const interfaces = [this.paymentMethodInterfaceEnum.TEF, this.paymentMethodInterfaceEnum.POS]

      if (this.form.paymentMethod.method === this.paymentTypeEnum.PIX) {
        interfaces.push(this.paymentMethodInterfaceEnum.MANUAL)
      }

      return interfaces
    },
    paymentMethodInterfacesShorcuts() {
      if (this.paymentMethodInterfaces.length > 1) {
        return this.paymentMethodInterfaces
          .filter(m => (this.isTefEnabled ? true : m !== 'Tef'))
          .map((m, index) => ({
            shortcut: [this.keyCode.ctrl, index + 1].join('+'),
            handler: () => {
              this.form.paymentMethodInterface = m
              return true // Returning true because we don't want other handlers for the same shortcut to be called later
            },
          }))
      }
      return []
    },
    paymentMethodInterfaceProp() {
      return this.form.paymentMethodInterface
    },

    hasPaymentMethodInterfaces() {
      const result = this.paymentMethodInterfaces.length

      if (this.inDevMode) return result

      if (this.isAtm) return false

      return result
    },
    isPOSMethod() {
      return this.form.paymentMethodInterface === this.paymentMethodInterfaceEnum.POS
    },
    isManualPixMethod() {
      return this.form.paymentMethodInterface === this.paymentMethodInterfaceEnum.MANUAL
    },
    isPixMethod() {
      return this.form.paymentMethod?.method === this.paymentTypeEnum.PIX
    },

    /**
     * Parcelamento vale para crédito nas interfaces TEF e POS.
     *
     * A diferença entre elas é quem conduz a transação, e isso muda o significado da escolha:
     * no TEF o PDV comanda o pinpad e a quantidade escolhida é o que será autorizado; no POS a
     * maquininha é operada pelo atendente, e o que o operador seleciona aqui é o registro do que
     * foi feito no equipamento. Nos dois casos a política define o que pode ser oferecido e qual
     * acréscimo aplicar.
     */
    isInstallmentEligibleMethod() {
      if (this.form.paymentMethod?.method !== this.paymentTypeEnum.CREDIT_CARD) return false

      // Chave geral da loja: desligada, nenhum canal parcela.
      if (!this.stIsInstallmentEnabled) return false

      if (this.form.paymentMethodInterface === this.paymentMethodInterfaceEnum.TEF) return true

      // No POS o parcelamento depende de a loja ter ligado a opção no cadastro: a transação já
      // foi capturada na maquininha quando o operador digita o NSU, então uma escolha fora da
      // política não pode ser recusada, só registrada como divergência. No TEF a validação
      // acontece antes da autorização, e por isso lá não há o que a loja precise assumir.
      if (this.form.paymentMethodInterface === this.paymentMethodInterfaceEnum.POS) {
        return this.stIsPosInstallmentEnabled
      }

      return false
    },

    /** No POS o operador informa o que fez na maquininha; o Sistema nao conduz nem confere. */
    isPosCreditMethod() {
      return (
        this.form.paymentMethod?.method === this.paymentTypeEnum.CREDIT_CARD &&
        this.form.paymentMethodInterface === this.paymentMethodInterfaceEnum.POS
      )
    },

    /** Só no TEF o PDV comanda a transação e recebe de volta a quantidade autorizada. */
    isTefCreditMethod() {
      return (
        this.form.paymentMethod?.method === this.paymentTypeEnum.CREDIT_CARD &&
        this.form.paymentMethodInterface === this.paymentMethodInterfaceEnum.TEF
      )
    },

    showInstallmentSelector() {
      return this.isInstallmentEligibleMethod && this.stHasInstallmentOptions
    },


    /**
     * A modalidade só é perguntada quando há mais de uma permitida. Com uma só, ela é aplicada
     * sem exibir (Req. 5.5).
     */
    showModeSelector() {
      return this.showInstallmentSelector && this.stAllowedModes.length > 1
    },

    /**
     * Rótulos das opções de parcelamento.
     *
     * Montados com template literal, e não com interpolação do `$t`: neste projeto o `$t` só
     * interpola quando a chave existe nos arquivos de tradução — passando texto cru como chave,
     * o vue-i18n devolve a própria string com os marcadores `{}` intactos.
     */
    installmentSelectOptions() {
      const currency = value => this.$options.filters.currency(value)

      return this.stInstallmentOptions.map(option => {
        const total = currency(option.chargedValue)

        if (option.installments === 1) {
          return { value: String(option.installments), label: `${this.$t('À vista')} - ${total}` }
        }

        const installmentValue = currency(option.installmentValue)

        return {
          // String, e não número: o vue-select casa o modelo com a opção comparando
          // `JSON.stringify(reduce(option))` com `JSON.stringify(value)`. Com o modelo do Vue
          // Formulate chegando como texto, um valor numérico aqui nunca casa — e o combo passa a
          // exibir o número cru em vez do rótulo da opção escolhida.
          value: String(option.installments),
          label: `${option.installments}x ${this.$t('de')} ${installmentValue} — ${this.$t(
            'total'
          )} ${total}`,
        }
      })

    },

    installmentModeOptions() {
      const labels = {
        Cash: this.$t('À vista'),
        Store: this.$t('Parcelado sem juros'),
        Issuer: this.$t('Parcelado com juros'),
      }

      return this.stAllowedModes.map(mode => ({ value: mode, label: labels[mode] || mode }))
    },


    /**
     * Valor do pagamento sem o acréscimo de parcelamento.
     *
     * O acréscimo não abate saldo nem vira troco: é dinheiro que o cliente paga a MAIS e a
     * loja recebe. Só o valor sem acréscimo quita a venda. Comparar o valor cobrado com o
     * saldo leria o acréscimo como pagamento em excesso — e isso não seria só cosmético:
     * troco em pagamento que não é dinheiro é recusado aqui e no servidor, então a venda
     * nem chegaria a ser registrada.
     */
    valueWithoutSurcharge() {
      return roundDecimal(
        (Number(this.form.value) || 0) - (Number(this.form.surchargeValue) || 0)
      )
    },
  },

  watch: {
    paymentMethodInterfaceProp(val) {
      this.$nextTick(() => {
        if (val === this.paymentMethodInterfaceEnum.POS) {
          this.focusInput('#modal_value-input_nsu')
        } else if (val === this.paymentMethodInterfaceEnum.MANUAL) {
          if (!this.form.documentTitular) {
            this.form.documentTitular = this.getCustomerDocument
          }

          this.$nextTick(() => {
            this.focusInput('#modal_value-input_document_titular')
          })
        }
      })
    },

    /**
     * As opções dependem do valor: a política tem valor mínimo de venda e de parcela. Recarregar
     * na troca de interface cobre o caso de o operador alternar entre TEF e POS.
     */
    isInstallmentEligibleMethod: {
      immediate: true,
      handler(isCredit) {
        if (isCredit) {
          this.loadInstallmentOptions()
          return
        }

        // Zerar o acréscimo junto, e não só as parcelas: escolher 6x no TEF e depois trocar para
        // um meio sem parcelamento deixaria no formulário um acréscimo que nada mais justifica —
        // ele seguiria para o pagamento e para o total da venda.
        this.form.installmentCount = '1'
        this.form.installmentMode = null
        this.form.installmentValue = 0
        this.form.surchargeValue = 0
        this.stCleanInstallmentState()
        this.onUpdateValue(this.form.value)
      },
    },
  },
  methods: {
    ...mapActions('pages/pdv/payBox', {
      stSetPaymentIntegrationStatus: 'setPaymentIntegrationStatus',
      stSetGenericTefTransactionFailed: 'setGenericTefTransactionFailed',
    }),

    /**
     * Digitar um valor invalida a escolha de parcelamento: as opções — e o acréscimo — foram
     * calculadas para o valor anterior. Voltar para uma parcela evita carregar um acréscimo
     * que não corresponde mais a nada, e recarrega as opções para o novo valor.
     *
     * O primeiro retorno não é defensividade: o `onChangeInstallments` grava o valor cobrado
     * NESTE mesmo campo, e o Vue Formulate emite `input` nessa gravação exatamente como se o
     * operador tivesse digitado — o setter do modelo só compara se o valor mudou, não de onde
     * veio. Sem separar os dois casos, escolher 6x caía aqui e devolvia o combo para "À vista"
     * no mesmo instante.
     */
    onValueTyped(value) {
      const selectedOption = this.stOptionByInstallments(this.form.installmentCount)
      const isOwnWrite =
        selectedOption != null && Number(value) === Number(selectedOption.chargedValue)

      if (isOwnWrite) return

      if (Number(this.form.installmentCount) > 1) {
        this.form.installmentCount = '1'
        this.form.installmentValue = 0
        this.form.surchargeValue = 0
      }

      this.onUpdateValue(value)
      this.reloadInstallmentOptions()
    },

    // eslint-disable-next-line func-names
    onUpdateValue: _.debounce(function (value) {
      const netValue = roundDecimal(
        (Number(value) || 0) - (Number(this.form.surchargeValue) || 0)
      )
      const changeValue = this.calcChange(this.balanceValue, netValue)
      if (changeValue > 0) {
        this.balanceValueUpdated = 0
        this.change = changeValue
      } else {
        this.balanceValueUpdated = roundDecimal(this.balanceValue - netValue)
        this.change = 0
      }
    }, 500),

    // eslint-disable-next-line func-names
    reloadInstallmentOptions: _.debounce(function () {
      this.loadInstallmentOptions()
    }, 500),

    calcChange(total, value) {
      let change = 0
      const result = roundDecimal(total - value)
      if (result < 0) {
        change = Math.abs(result)
      } else {
        change = 0
      }
      return change
    },

    onResetValue() {
      this.form.value = 0
      this.balanceValueUpdated = this.balanceValue
      this.$formulate.resetValidation('formReceiveValue')
    },

    /** method for atm payment, it not show modal */
    /**
     * Pagamento no ATM: sem modal, porque quem opera é o próprio cliente e a escolha já foi
     * feita nas telas anteriores.
     *
     * `installmentOption` é a opção de parcelamento escolhida na tela do ATM, quando houve
     * escolha. Ela chega pronta de propósito: o seletor daqui é o do operador de caixa, com
     * `vue-select` e teclado, que não serve para uma tela sensível ao toque.
     */
    async payOnAtm(paymentMethod, installmentOption = null) {
      this.resetModal()

      if (!this.isAtm) {
        this.showWarning({ message: 'Este pagamento funciona apenas no ATM.' })
        return
      }

      this.form = { ...this.form, paymentMethod, value: this.balanceValue }

      if (this.isTefEnabled) {
        this.form.paymentMethodInterface = paymentMethodInterfaceEnum.TEF
      } else if (this.mxIsDevelopment) {
        this.form.paymentMethodInterface = paymentMethodInterfaceEnum.POS
        this.form.nsu = '1100220033'
        this.form.cardBrand = 'MASTERCARD'
      } else {
        this.showWarning({ message: 'Para realizar pagamentos, o TEF deve estar habilitado.' })
        return
      }

      this.applyInstallmentOption(installmentOption)

      await this.onConfirm()
    },

    /**
     * Carimba no formulário a opção de parcelamento já escolhida.
     *
     * O pagamento passa a valer o valor COBRADO, que inclui o acréscimo quando a política
     * repassa: é ele que a adquirente autoriza e que a nota declara. O valor da parcela vem do
     * rateio do servidor e é guardado, não recalculado — dividir o total por N na exibição daria
     * um número diferente do que o cliente viu ao escolher.
     */
    applyInstallmentOption(option) {
      if (!option || Number(option.installments) <= 1) return

      this.form.installmentCount = String(option.installments)
      this.form.installmentMode = option.installmentMode || this.stDefaultMode
      this.form.installmentValue = option.installmentValue
      this.form.surchargeValue = option.surchargeValue
      this.form.value = option.chargedValue
    },

    showModal(paymentMethod) {
      this.$bvModal.show('modal-value')
      this.resetModal()

      this.form = { ...this.form, paymentMethod, value: this.balanceValue }

      if (!this.paymentMethodInterfaces.length) {
        this.form.paymentMethodInterface = this.paymentMethodInterfaceEnum.MANUAL
      }

      if (this.hasShortcut) {
        this.addModalShortcuts()
      }

      this.$nextTick(() => {
        this.titleModal = `Pagar com: ${this.form.paymentMethod.name}`
        if (
          this.form.paymentMethodInterface !== this.paymentMethodInterfaceEnum.POS &&
          this.form.paymentMethodInterface !== this.paymentMethodInterfaceEnum.MANUAL
        ) {
          this.focusInput('#modal_value-input_value')
        }
      })
    },
    hideModal() {
      this.shortcuts.reset()
      this.$bvModal.hide('modal-value')
    },

    resetModal() {
      this.form = getInitialReceiptForm()
      this.change = 0

      this.balanceValueUpdated = 0
    },

    ...mapActions('pages/pdv/payBoxInstallment', {
      stFetchInstallmentOptions: 'fetchInstallmentOptions',
      stCleanInstallmentState: 'cleanState',
    }),

    /**
     * Carrega as opções de parcelamento para o valor corrente.
     *
     * É disparado ao entrar no crédito (TEF ou POS) e ao mudar o valor: a política tem valor mínimo
     * de venda e valor mínimo de parcela, então as opções dependem do valor.
     */
    async loadInstallmentOptions() {
      if (!this.isInstallmentEligibleMethod) {
        this.stCleanInstallmentState()
        return
      }

      await this.stFetchInstallmentOptions({ saleValue: this.valueWithoutSurcharge })

      // Uma parcela é o estado inicial: o operador escolhe parcelar, nunca o contrário.
      if (!this.form.installmentCount) {
        this.form.installmentCount = '1'
      }

      this.form.installmentMode = this.stDefaultMode
    },

    /**
     * Ao trocar a quantidade de parcelas, o pagamento passa a valer o valor COBRADO — que inclui o
     * acréscimo quando a política repassa. É esse valor que a adquirente autoriza e que a nota
     * declara.
     *
     * O valor da parcela é gravado no recebimento, e não recalculado na exibição: ele vem do rateio
     * do servidor, que trunca e joga o resto numa parcela específica para a soma fechar exata.
     * Dividir o total por N na tela produziria um número diferente do que foi mostrado ao cliente
     * na hora de escolher.
     */
    onChangeInstallments(installments) {
      // O Vue Formulate normaliza o valor das opções de `vue-select` para string; sem converter,
      // a busca pela opção falha e o valor cobrado nunca é aplicado.
      const count = Number(installments) || 1
      const option = this.stOptionByInstallments(count)

      if (!option) return

      this.form.installmentCount = String(count)
      this.form.installmentValue = option.installmentValue
      this.form.surchargeValue = option.surchargeValue
      this.form.value = option.chargedValue

      this.onUpdateValue(option.chargedValue)
    },


    /**
     * Confere a quantidade autorizada contra a solicitada.
     *
     * A adquirente pode autorizar um parcelamento diferente do pedido. Registrar em silêncio
     * faria a venda fechar com um plano que o cliente não escolheu, então o operador confirma —
     * e, não confirmando, a transação é cancelada na adquirente antes de qualquer registro.
     */
    async confirmAuthorizedInstallments(tefResult) {
      const requested = Number(this.form.installmentCount) || 1
      const authorized = Number(tefResult?.installmentCount) || requested

      if (authorized === requested) return true

      const confirmed = await this.confirm({
        title: this.$t('Parcelamento divergente'),
        text: `${this.$t('Foi solicitado')} ${requested}x ${this.$t(
          'e a adquirente autorizou'
        )} ${authorized}x. ${this.$t('Confirma o pagamento com')} ${authorized}x?`,

        // No ATM a pergunta é feita ao cliente, sozinho na frente do quiosque. Clique fora e ESC
        // fechariam o diálogo como recusa, e recusa aqui cancela na adquirente uma transação já
        // autorizada — caro demais para um toque acidental.
        allowOutsideClick: !this.isAtm,
        allowEscapeKey: !this.isAtm,
      })


      if (confirmed) {
        this.form.installmentCount = String(authorized)
        return true
      }

      try {
        this.showLoadingOverlay(this.$t('Cancelando transação...'))

        await window.electronAPI.tef.creditPaymentCancel(this.tefAgentConfigPayload, {
          saleId: this.saleUuid,
          amount: this.form.value,
          nsu: tefResult.nsuGateway || tefResult.nsu,
          originalDate: tefResult.transactionDate,
        })

        this.showWarning({
          title: this.$t('Pagamento TEF'),
          message: this.$t('Transação cancelada na adquirente.'),
        })
      } catch (error) {
        // O cancelamento falhou e a transação continua viva na adquirente. Não registrar o
        // pagamento aqui deixaria a venda sem contrapartida de um valor que foi cobrado, então o
        // caso é reportado ao operador para tratamento manual.
        this.showError({
          error,
          message: this.$t(
            'Não foi possível cancelar a transação na adquirente. Verifique no portal antes de refazer o pagamento.'
          ),
        })
      } finally {
        this.hideLoadingOverlay()
      }

      return false
    },

    async onConfirm() {
      await new Promise(resolve => setTimeout(() => resolve(), 100))
      if (this.isBusy) return

      try {
        this.loadingPaymentConfirmation = true

        this.form.addedDate = moment().format()

        if (this.$refs.formReceiveValue) {
          this.$refs.formReceiveValue.showErrors()
        }

        if (!this.validation()) return

        let tefResult
        if (
          this.paymentMethodInterfaces.length &&
          this.form.paymentMethodInterface === this.paymentMethodInterfaceEnum.TEF
        ) {
          await initMonitoring({ isTefAction: true })

          const tefPayload = {
            saleId: this.saleUuid,
            amount: this.form.value,

            // Ausentes ou 1 significam a vista: e o que mantem compativel o Agent que ainda nao
            // conhece parcelamento.
            installments: Number(this.form.installmentCount) || 1,
            installmentMode: this.form.installmentMode,
          }

          this.showLoadingOverlay(this.$t('PAY_BOX_SALE.TEF.START_TEF_PAYMENT'))

          try {
            await this.stSetPaymentIntegrationStatus(true)

            switch (this.form.paymentMethod.method) {
              case this.paymentTypeEnum.CREDIT_CARD:
                tefResult = await window.electronAPI.tef.creditPayment(
                  this.tefAgentConfigPayload,
                  tefPayload
                )
                break
              case this.paymentTypeEnum.DEBIT_CARD:
                tefResult = await window.electronAPI.tef.debitPayment(
                  this.tefAgentConfigPayload,
                  tefPayload
                )
                break
              case this.paymentTypeEnum.PIX:
                // eslint-disable-next-line no-case-declarations
                let callback = qrResult => {
                  this.showLoadingOverlayV2({
                    text: this.$t('QR Code para pagamento'),
                    image: `data:image/png;base64,${qrResult.qrCodeContent}`,
                    // customComponent: { // comentado pois o agent não consegue realizar 2 ações ao msm tempo.
                    //   name: 'EOverlaySectionPaymentAction',
                    //   props: {
                    //     receipt: this.form,
                    //     qrCodeImagePath: qrResult.qrCodePath
                    //   }
                    // }
                  })
                }
                window.electronAPI.tef.displayQrCode(callback)

                tefResult = await window.electronAPI.tef.pixPayment(
                  this.tefAgentConfigPayload,
                  tefPayload
                )
                callback = () => {}
                break
              default:
                throw new Error(
                  `Payment Method: ${this.form.paymentMethod.method} not implemented yet !`
                )
            }

            this.form.authorizationApprovalCode = tefResult?.authorizationApprovalCode
            this.form.nsu = tefResult.nsu || tefResult.nsuGateway || tefResult.transactionIdentifier
            this.form.cardBrand = tefResult.cardBrand

            // Conferência da quantidade autorizada, antes de qualquer registro do pagamento.
            if (
              this.isTefCreditMethod &&
              (Number(this.form.installmentCount) || 1) > 1 &&
              !tefResult.transactionFailed
            ) {
              const accepted = await this.confirmAuthorizedInstallments(tefResult)
              if (!accepted) {
                this.hideModal()
                return
              }
            }


            if (tefResult.transactionFailed) {
              if (isTefPix(this.form)) {
                this.form.tefTransactionFailed = true
              } else if (isTefCard(this.form)) {
                this.showWarning({
                  title: this.$t('Pagamento TEF'),
                  message: this.$t('Problema na comunicação do PINPAD com a adquirente.'),
                })

                this.stSetGenericTefTransactionFailed(true)

                this.hideModal()
                return
              }
            }
          } catch (error) {
            if (error.canceled) {
              this.showWarning({
                title: this.$t('Pagamento TEF'),
                message: this.$t(
                  error.displayMessage || 'Operação cancelada no equipamento PINPAD'
                ),
              })
            } else {
              console.error('tef-error', error)
              this.showError({ error })
            }
            this.hideModal()
            return
          } finally {
            await this.stSetPaymentIntegrationStatus(false)
            this.hideLoadingOverlay()
          }
        }

        this.$emit('click-confirm', {
          ...this.form,
          change: this.calcChange(this.balanceValue, this.valueWithoutSurcharge),
          tefPayment: tefResult,
        })
      } finally {
        this.loadingPaymentConfirmation = false
      }
    },

    addModalShortcuts() {
      const { esc, ctrl, enter } = this.keyCode

      this.shortcuts.add([
        {
          shortcut: esc,
          handler: () => {
            if (this.loadingPaymentConfirmation) {
              return true
            }

            this.hideModal()
            return true
          },
        },
        {
          shortcut: [ctrl, enter].join('+'), // get 'Enter' and 'NumpadEnter' keys
          handler: () => {
            this.onConfirm()
            return true
          },
        },
      ])
      this.shortcuts.add(this.paymentMethodInterfacesShorcuts)
    },

    validation() {
      const { value, nsu, documentTitular, cardBrand } = this.form

      if (!value || value < 0.01) return false
      if (this.hasPaymentMethodInterfaces) {
        const hasEmptyPOSFields = !nsu || (!this.isPixMethod && !cardBrand)
        if (this.isPOSMethod && hasEmptyPOSFields) return false

        if (this.isPOSMethod && nsu <= 0) return false
        if (this.isManualPixMethod && documentTitular && !validateBr.cpfcnpj(documentTitular || ''))
          return false
      }

      if (this.form.paymentMethod.method !== this.paymentTypeEnum.CASH) {
        const change = this.calcChange(this.balanceValue, this.valueWithoutSurcharge)
        if (change > 0) {
          this.showError({
            title: this.$t('Troco não permitido'),
            message: this.$t(
              'PAY_BOX_SALE.PAYMENT.UI.EXCHANGE_IS_ONLY_ALLOWED_IN_CASH_PAYMENT_METHOD'
            ),
          })
          return false
        }
      }

      return true
    },
  },
}
</script>

<style lang="scss" scoped>
.input-size {
  font-size: 1.4rem;
}

.btn-shortcut {
  padding: 10px;
}

.fade-enter-active,
.fade-leave-active {
  transition: 0.2s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(-20px);
}
</style>
